import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ClausesService {
  constructor(private http: HttpClient) {}

  getClauses() {
    return this.http.get(`${environment.apiUrl}/trackvision/clauses`);
  }

  getClausesRequitement(requirementId,templateId) {
    return this.http.get(`${environment.apiUrl}/trackvision/clauses/getrequirement/${requirementId}/${templateId}`);
  }

  getClause(id) {
    return this.http.get(`${environment.apiUrl}/trackvision/clauses/get/${id}`);
  }
  createClause(body) {
    return this.http.post(
      `${environment.apiUrl}/globalvision/clause/create`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  addClause(body) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/clauses/create`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }

  updateClause(body) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/clauses/update`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }

  removeClause(body) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/clauses/delete`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
}
